import { createFileRoute, Navigate } from '@tanstack/react-router'

export const Route = createFileRoute('/(redirects)/partner/$organization/users/$userId')({
  component: () => <Navigate replace search from="/partner/$organization/users/$userId" to="/bo/users/$userId" />,
})
